module.exports = {"apiKey":"AIzaSyBH6WKJ3T4JJmucGGleuXVgLyBvACzvciA","authDomain":"flowerai-stage.firebaseapp.com","databaseURL":"https://flowerai-stage.firebaseio.com","projectId":"flowerai-stage","storageBucket":"flowerai-stage.appspot.com","messagingSenderId":"455375558062"}


//////////////////
// WEBPACK FOOTER
// ./src/secrets/firebase-config.json
// module id = 495
// module chunks = 0